import { Expose, Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class TrackerClassPacingModel {
	@Transform(dateTransformer)
	start_date: Date;
	weeks: number;
}

export class TrackerClassModel {
	id: number;
	title: string;
	assignment_count: number;
	assignment_completed: number;
	@Expose({ name: 'success' })
	grade: number;
	progress: number;
	notes: string;
	@Transform(dateTransformer)
	end_date: Date;
	@Type(TrackerClassPacingModel_ClassTransform_Type)
	pacing: TrackerClassPacingModel[];
	@Transform(dateTransformer)
	complete_date?: Date;
	@Transform(dateTransformer)
	counted_month?: Date;
	registration_type: string;
	pending_final: boolean;
	@Expose({ name: 'success_zero' })
	grade_zero: number;
	lms: string;
	teacher: {
		name: string;
		uid: number;
	};
}

export function TrackerClassModel_ClassTransform_Type() {
	return TrackerClassModel;
}
export function TrackerClassPacingModel_ClassTransform_Type() {
	return TrackerClassPacingModel;
}
